import withService from './withService'

const $SlideOut = ({ service, onCloseBtnClick }) => {
    const createMarkup = () => {
        const { name, description } = service
        return { __html: `<h2 class="title">${name}</h2> ${description}` }
    }

    const handleCloseBtnClick = () => {
        onCloseBtnClick(service)
    }

    const activeClass = service ? 'active' : ''

    return (
        <div className={`slide-out container-fluid ${activeClass}`}>
            {service && (
                <div className="container">
                    <div className="row">
                        {service.image && (
                            <div className="col text-center image flex-last">
                                <Image title={service.name} alt={service.name} image={service.image} />
                            </div>
                        )}
                        <div className="col text flex-first" dangerouslySetInnerHTML={createMarkup()} />
                        <div className="close-btn" onClick={handleCloseBtnClick} />
                    </div>
                </div>
            )}
        </div>
    )
}
const SlideOut = withService($SlideOut)

export default SlideOut
